import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { SetMetaTags } from "../../Components/Utility/setMetaTags";
import wLogo from "../../Assests/images/w_logo.png";
import "../../Assests/Css/blog.css";

function Unsubscribe() {
  const { token } = useParams();

  const [status, setStatus] = useState("loading"); // "loading" | "success" | "error" | "invalid"
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!token) {
      setStatus("invalid");
      setMessage("No unsubscribe token was provided.");
      return;
    }

    const doUnsubscribe = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE}/unsubscribe/${token}`
        );

        if (res.data && res.data.status) {
          setStatus("success");
          setMessage(
            res.data.message ||
              "You have been successfully unsubscribed from our mailing list."
          );
        } else {
          setStatus("error");
          setMessage(
            res.data?.message ||
              "We could not process your request. The link may have already been used or expired."
          );
        }
      } catch (err) {
        const errMsg =
          err.response?.data?.message ||
          "Something went wrong. Please try again later.";
        setStatus("error");
        setMessage(errMsg);
      }
    };

    doUnsubscribe();
  }, [token]);

  return (
    <div className="unsubscribe-page">
      <SetMetaTags
        title="Unsubscribe - Weyfarin"
        description="Unsubscribe from Weyfarin email updates."
      />

      <div className="unsubscribe-container">
        {/* Logo */}
        <div className="unsubscribe-logo">
          <Link to="/">
            <img src={wLogo} alt="Weyfarin" title="Weyfarin" />
          </Link>
        </div>

        {/* Card */}
        <div className="unsubscribe-card">
          {status === "loading" && (
            <div className="unsubscribe-state">
              <div className="unsubscribe-spinner" aria-label="Loading"></div>
              <h2>Processing your request…</h2>
              <p>Please wait while we unsubscribe you from our mailing list.</p>
            </div>
          )}

          {status === "success" && (
            <div className="unsubscribe-state">
              <div className="unsubscribe-icon unsubscribe-icon--success">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </div>
              <h2>You're unsubscribed</h2>
              <p>{message}</p>
              <p className="unsubscribe-note">
                You won't receive any further emails from us. Changed your mind?{" "}
                <Link to="/blogs" className="unsubscribe-link">
                  Visit our journal
                </Link>{" "}
                and resubscribe anytime.
              </p>
              <Link to="/" className="unsubscribe-home-btn">
                Back to Home
              </Link>
            </div>
          )}

          {status === "error" && (
            <div className="unsubscribe-state">
              <div className="unsubscribe-icon unsubscribe-icon--error">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10" />
                  <line x1="12" y1="8" x2="12" y2="12" />
                  <line x1="12" y1="16" x2="12.01" y2="16" />
                </svg>
              </div>
              <h2>Unable to unsubscribe</h2>
              <p>{message}</p>
              <p className="unsubscribe-note">
                If you continue to receive emails, please contact us at{" "}
                <a href="mailto:contact@weyfarin.com" className="unsubscribe-link">
                  contact@weyfarin.com
                </a>
              </p>
              <Link to="/" className="unsubscribe-home-btn">
                Back to Home
              </Link>
            </div>
          )}

          {status === "invalid" && (
            <div className="unsubscribe-state">
              <div className="unsubscribe-icon unsubscribe-icon--error">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </div>
              <h2>Invalid link</h2>
              <p>This unsubscribe link is invalid or has expired.</p>
              <Link to="/" className="unsubscribe-home-btn">
                Back to Home
              </Link>
            </div>
          )}
        </div>

        <p className="unsubscribe-footer">
          © {new Date().getFullYear()} Weyfarin. All rights reserved.
        </p>
      </div>
    </div>
  );
}

export default Unsubscribe;
